import events from '../../../../events.js'

const {
  ACCESS_TO_AD_INSERTION_CLICKED,
  AD_FAVORITED,
  AD_INSERTION_IO_CAR_DETAILS_SUCCESS,
  AD_IMPRESSIONS_COLLECTED,
  AD_INSERTED,
  AD_MODIFIED,
  AD_SHARED,
  AI_SEARCH_USED,
  ALERT_CREATED,
  DEALER_STOCK_CLICKED,
  DETAIL_NAVBAR_CLICKED,
  LIST_NEWS_SAVED_CLICKED,
  LIST_NEWS_SAVED_VIEWED,
  NEWS_DETAIL_VIEWED,
  DETAIL_VIEWED,
  FILTER_ADDED,
  FILTERS_RESTART_CLICKED,
  HOME_IO_BUTTON_CLICKED,
  LAST_DETAILS_SEEN,
  LEAD_ERROR,
  LEAD_TRIGGERED,
  LIST_VIEWED,
  MAP_CLICKED,
  PHONE_VIEWED,
  SEND_MESSAGE_BUTTON_CLICKED,
  WEBSITE_CLICKED
} = events

const eventVersions = {
  [ACCESS_TO_AD_INSERTION_CLICKED]: 2,
  [AD_INSERTION_IO_CAR_DETAILS_SUCCESS]: 1,
  [AD_FAVORITED]: 8,
  [AD_IMPRESSIONS_COLLECTED]: 5,
  [AD_INSERTED]: 8,
  [AD_MODIFIED]: 2,
  [AD_SHARED]: 7,
  [AI_SEARCH_USED]: 2,
  [ALERT_CREATED]: 2,
  [DEALER_STOCK_CLICKED]: 2,
  [DETAIL_NAVBAR_CLICKED]: 1,
  [LIST_NEWS_SAVED_CLICKED]: 2,
  [LIST_NEWS_SAVED_VIEWED]: 1,
  [NEWS_DETAIL_VIEWED]: 4,
  [DETAIL_VIEWED]: 13,
  [FILTER_ADDED]: 2,
  [FILTERS_RESTART_CLICKED]: 2,
  [HOME_IO_BUTTON_CLICKED]: 2,
  [LAST_DETAILS_SEEN]: 2,
  [LEAD_ERROR]: 1,
  [LEAD_TRIGGERED]: 17,
  [LIST_VIEWED]: 5,
  [MAP_CLICKED]: 2,
  [PHONE_VIEWED]: 2,
  [SEND_MESSAGE_BUTTON_CLICKED]: 1,
  [WEBSITE_CLICKED]: 2
}
export default ({payload, next}) => {
  const {
    obj: {
      context: {protocols = {}},
      event
    }
  } = payload

  if (Object.keys(eventVersions).includes(event)) {
    payload.obj.context.protocols = {
      ...protocols,
      event_version: eventVersions[event]
    }
  }

  next(payload)
}
